import { Schema } from "effect";
export const Id = Schema.TemplateLiteral(Schema.Literal("acct_"), Schema.String).pipe(Schema.annotations({
    identifier: "StripeAccountId",
    description: "A Stripe account identifier.",
    examples: [
        "acct_1234567890",
        "acct_abcdefghij"
    ],
    externalReferenceUrl: "https://stripe.com/docs/api/accounts/object#account_object-id"
}), Schema.brand("StripeAccountId"));
